import { httpRequest } from "@/axios/axios-api";
import Vue from "vue";

const LEAVE_EXAM_WARNING_TEXT =
  "您还没有提交答卷，确定需要退出吗，退出后自动提交答卷，本次考试机会将扣除";

export default {
  data() {
    return {
      majorName: "", // 专业的名字
      questionList: [],
      currentQuestionIdx: 0,
      currentQuestion: {},
      questionAnswerList: [], // 用户已答的所有问题的列表，长度与questionList一致，存储用户的答案，每道题存储选中的选项的sort值，多选题的情况，多个选项之间以英文逗号隔开，格式为：[{"ftqId"：123，"answer":"A,B", "eqId": 123}]
      optionSelectList: [], // 各个题目选择的状态记录，[{A:true, B:false}]
      isSubmitted: false, // 是否已提交答卷
      timer: null, // 计时器
      timerDuration: 0, // 考试倒计时进行中的当前时间，秒数
      timerStr: "00:00", // 考试倒计时时间，字符串，xx:xx
      examCostTimeString: "00分00秒", // 考试结束后总用时字符串，xx分xx秒
      examTotalDuration: 0, // 考试允许总时长，秒数
      ftId: 0, // 当前考试的id
      resultIcon: require("@/assets/exam/formal_exam_fail.png"), // 考试结果图标
      examResult: null, // 提交答案后返回的结果
      loadingQuestionList: true, // 是否正在加载问题列表
      submittingAnswers: false, // 正在提交答卷标志
      showCertOverlay: false, // 是否显示证书遮罩层
      uploadDialogVisible: false, // 是否显示上传弹窗
      paperName: "", // 选择上传的论文名字
      selectBtnIcon: require("@/assets/exam/icon_upload.png"),
      paperAuthStatus: 0, // 0未上传、1审核中、2审核通过、3审核驳回
      paperFile: null, // 选中的文件对象
      uploadingPaper: false, // 是否正在上传论文
      lastLoadedRouteKey: "", // 最近一次加载考试数据时的路由参数快照
      beforeUnloadBound: false, // 是否已绑定页面关闭提醒
      handlingLeaveGuard: false // 是否正在处理离开拦截
    };
  },
  created() {
    this.initPage();
  },
  mounted() {
    this.registerBeforeUnload();
  },
  activated() {
    this.registerBeforeUnload();
    if (this.$route.name !== "FormalExam" || this.loadingQuestionList) {
      return;
    }
    const routeFtId = this.getRouteFtId();
    if (!routeFtId) {
      this.initPage();
      return;
    }
    const currentRouteKey = this.getCurrentRouteKey();
    const needReloadByRoute = currentRouteKey !== this.lastLoadedRouteKey;
    if (needReloadByRoute) {
      this.initPage();
    }
  },
  deactivated() {
    this.unregisterBeforeUnload();
  },
  beforeDestroy() {
    this.unregisterBeforeUnload();
    this.clearTimer();
  },
  beforeRouteLeave: function(to, from, next) {
    this.handleRouteLeave(to, from, next);
  },
  methods: {
    clearTimer() {
      if (this.timer !== null) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    isExamAnsweringInProgress() {
      return (
        !this.loadingQuestionList &&
        !this.isSubmitted &&
        Array.isArray(this.questionList) &&
        this.questionList.length > 0 &&
        Number(this.ftId) > 0
      );
    },
    registerBeforeUnload() {
      if (this.beforeUnloadBound) {
        return;
      }
      window.addEventListener("beforeunload", this.handleBeforeUnload);
      this.beforeUnloadBound = true;
    },
    unregisterBeforeUnload() {
      if (!this.beforeUnloadBound) {
        return;
      }
      window.removeEventListener("beforeunload", this.handleBeforeUnload);
      this.beforeUnloadBound = false;
    },
    handleBeforeUnload(event) {
      if (!this.isExamAnsweringInProgress()) {
        return undefined;
      }
      event.preventDefault();
      event.returnValue = LEAVE_EXAM_WARNING_TEXT;
      return LEAVE_EXAM_WARNING_TEXT;
    },
    cleanupLeaveState(to, from) {
      this.clearTimer();
      if (to.name === "ExamRecord") {
        from.meta.keepAlive = false;
        this.$destroy();
      }
    },
    async handleRouteLeave(to, from, next) {
      if (this.submittingAnswers) {
        this.$message.warning("答卷正在提交，请稍候");
        next(false);
        return;
      }
      if (!this.isExamAnsweringInProgress()) {
        this.cleanupLeaveState(to, from);
        next();
        return;
      }
      if (this.handlingLeaveGuard) {
        next(false);
        return;
      }
      this.handlingLeaveGuard = true;
      try {
        await this.$confirm(LEAVE_EXAM_WARNING_TEXT, "提示", {
          confirmButtonText: "确认退出",
          cancelButtonText: "继续答题",
          closeOnPressEscape: false,
          closeOnHashChange: false,
          closeOnClickModal: false,
          showClose: false,
          type: "warning"
        });
      } catch (error) {
        this.handlingLeaveGuard = false;
        next(false);
        return;
      }

      const autoSubmitSuccess = await this.submitAnswers({
        showResult: false,
        showSuccessMessage: false,
        autoSubmitOnLeave: true
      });
      this.handlingLeaveGuard = false;
      if (!autoSubmitSuccess) {
        next(false);
        return;
      }
      this.cleanupLeaveState(to, from);
      next();
    },
    parsePositiveInt(value) {
      const num = Number(value);
      if (!Number.isFinite(num) || num <= 0) {
        return null;
      }
      return Math.floor(num);
    },
    getRouteErId() {
      return this.parsePositiveInt(this.$route.query.erId);
    },
    getRouteFtId() {
      return this.parsePositiveInt(this.$route.query.ftId);
    },
    getCurrentRouteKey() {
      return `ftId:${this.getRouteFtId() || ""}|erId:${this.getRouteErId() ||
        ""}`;
    },
    async initPage() {
      this.loadingQuestionList = true;
      this.clearTimer();
      const ftId = this.getRouteFtId();
      if (ftId) {
        this.loadQuestionList();
        return;
      }
      const access = await this.checkTrainingAccess();
      if (!access.allowed) {
        this.$message.warning(access.message);
        this.$router.replace("/studyPage");
        return;
      }
      // 加载考题
      this.loadQuestionList();
    },
    async checkTrainingAccess() {
      try {
        const routeErId = this.getRouteErId();
        if (routeErId) {
          const detailRes = await httpRequest("/app/exam/exam/info", "get", {
            erId: routeErId
          });
          if (!detailRes || detailRes.code !== 200 || !detailRes.data) {
            return {
              allowed: false,
              message: "请先报名对应培训班"
            };
          }
          const currentExam = detailRes.data || {};
          const examCount = Number(
            currentExam && currentExam.apply && currentExam.apply.examCount
          );
          if (Number.isFinite(examCount) && examCount >= 2) {
            return {
              allowed: false,
              message: "考试已结束"
            };
          }
          const start = this.parseDateTime(currentExam.examStartTime);
          if (start && Date.now() < start.getTime()) {
            return {
              allowed: false,
              message: this.buildTheoryStudyLockedMessage(currentExam)
            };
          }
          return { allowed: true, message: "" };
        }
        const res = await httpRequest(
          "/app/exam/exam/yet-enroll-exams",
          "get",
          null
        );
        if (
          !res ||
          res.code !== 200 ||
          !Array.isArray(res.data) ||
          res.data.length === 0
        ) {
          return {
            allowed: false,
            message: "请先报名对应培训班"
          };
        }
        const currentExam = res.data[0] || {};
        const examCount = Number(
          currentExam && currentExam.apply && currentExam.apply.examCount
        );
        if (Number.isFinite(examCount) && examCount >= 2) {
          return {
            allowed: false,
            message: "考试已结束"
          };
        }
        const start = this.parseDateTime(currentExam.examStartTime);
        if (start && Date.now() < start.getTime()) {
          return {
            allowed: false,
            message: this.buildTheoryStudyLockedMessage(currentExam)
          };
        }
        return { allowed: true, message: "" };
      } catch (error) {
        void error;
        return {
          allowed: false,
          message: "请先报名对应培训班"
        };
      }
    },
    parseDateTime(value) {
      if (!value) {
        return null;
      }
      const normalized = String(value).replace(/-/g, "/");
      const parsed = new Date(normalized);
      if (!Number.isNaN(parsed.getTime())) {
        return parsed;
      }
      const fallback = new Date(value);
      return Number.isNaN(fallback.getTime()) ? null : fallback;
    },
    formatDateTime(value) {
      const date = this.parseDateTime(value);
      if (!date) {
        return "-";
      }
      const year = date.getFullYear();
      const month = `${date.getMonth() + 1}`.padStart(2, "0");
      const day = `${date.getDate()}`.padStart(2, "0");
      const hour = `${date.getHours()}`.padStart(2, "0");
      const minute = `${date.getMinutes()}`.padStart(2, "0");
      const second = `${date.getSeconds()}`.padStart(2, "0");
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    buildTheoryStudyLockedMessage(exam) {
      return `暂未开启，理论学习时间：${this.formatDateTime(
        exam && exam.examStartTime
      )}~${this.formatDateTime(exam && exam.examEndTime)}`;
    },
    downloadCert() {
      // var a = document.createElement("a");
      // // const user = JSON.parse(localStorage.getItem("pc_user"));
      // a.download = "1213";
      //   // user.realName + "_" + this.examResult.majorName + "_资格证书";
      // // 设置图片地址
      // a.href = this.examResult.certificateUrl;
      // a.click();

      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      const _this = this;
      image.onload = function() {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;

        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/jpg");

        // 生成一个a元素
        var a = document.createElement("a");
        // 创建一个单击事件
        var event = new MouseEvent("click");

        // 将a的download属性设置为我们想要下载的图片名称
        const user = JSON.parse(localStorage.getItem("pc_user"));
        a.download =
          user.realName + "_" + _this.examResult.major + "_专科护士合格证书";
        // 将生成的URL设置为a.href属性
        a.href = url;

        // 触发a的单击事件
        a.dispatchEvent(event);
      };
      image.src = this.examResult.certificateUrl;
    },
    // 加载当前问题的统一方法
    renderQuestion() {
      this.currentQuestion = this.questionList[this.currentQuestionIdx];
    },
    showExamResult(_this, data) {
      // 显示考试结果
      _this.ftId = data.ftId;
      _this.examResult = data;
      _this.resultIcon = data.pass
        ? require("@/assets/exam/formal_exam_success.png")
        : require("@/assets/exam/formal_exam_fail.png");
      // 计算考试用时
      const cost = _this.examResult.duration;
      _this.examCostTimeString =
        (cost / 60 < 10
          ? "0" + parseInt(Math.max(0, parseInt(cost / 60)))
          : parseInt(Math.max(0, parseInt(cost / 60)))) +
        "分" +
        (cost % 60 < 10 ? "0" + parseInt(cost % 60) : parseInt(cost % 60)) +
        "秒";
      _this.isSubmitted = true;
    },
    // 点击单个选项时触发的事件
    answer_question(sort) {
      let curUserAnswer = this.questionAnswerList[this.currentQuestionIdx][
        "answer"
      ]; // 用户已经选中的答案

      // 如果已经选了，则取消选择，如果没有选，则选中
      if (this.optionSelectList[this.currentQuestionIdx][sort]) {
        // 从用户答案中取消这个答案
        // eslint-disable-next-line prefer-const
        let curUserAnswerList = curUserAnswer.split(",");
        for (let uaIdx = 0; uaIdx < curUserAnswerList.length; uaIdx++) {
          if (curUserAnswerList[uaIdx] === sort) {
            curUserAnswerList.splice(uaIdx, 1);
            break;
          }
        }
        this.questionAnswerList[this.currentQuestionIdx][
          "answer"
        ] = curUserAnswerList.join(",");
      } else {
        // 如果没选中，就选择上
        // 此时需要区分单选题还是多选题
        // 单选题的情况，要先把所有选项清空，再将当前选中的设置进去
        if (this.currentQuestion.type === 0) {
          // 单选题，清空用户已经选中的
          this.questionAnswerList[this.currentQuestionIdx]["answer"] = "";
          for (let curSort in this.optionSelectList[this.currentQuestionIdx]) {
            Vue.set(
              this.optionSelectList[this.currentQuestionIdx],
              curSort,
              false
            );
          }
          curUserAnswer = sort;
        } else {
          curUserAnswer.length > 0
            ? (curUserAnswer += "," + sort)
            : (curUserAnswer += sort);
        }

        this.questionAnswerList[this.currentQuestionIdx][
          "answer"
        ] = curUserAnswer;
      }
      // 最后设置选中状态
      this.optionSelectList[this.currentQuestionIdx][sort] = !this
        .optionSelectList[this.currentQuestionIdx][sort];
    },
    // 上一题
    previous_question() {
      if (this.currentQuestionIdx > 0) {
        this.currentQuestionIdx--;
        this.renderQuestion();
      }
    },
    // 下一题
    next_question() {
      if (this.currentQuestionIdx < this.questionList.length - 1) {
        this.currentQuestionIdx++;
        this.renderQuestion();
      } else {
        this.submitExam();
      }
    },
    // 提交问卷
    submitExam() {
      const unansweredCount = (this.questionAnswerList || []).filter(item => {
        if (!item) {
          return true;
        }
        const answer = item.answer;
        return !(typeof answer === "string" && answer.trim().length > 0);
      }).length;
      const confirmText =
        unansweredCount > 0
          ? "题目未答完，确认要交卷吗？"
          : "题目已全部作答，确认要交卷吗？";
      // 弹窗提醒用户是否提交问卷
      this.$confirm(confirmText, "提示")
        .then(() => {
          this.submitAnswers();
        })
        .catch(() => {});
    },
    async submitAnswers() {
      let options = {};
      if (
        arguments.length > 0 &&
        arguments[0] &&
        typeof arguments[0] === "object"
      ) {
        options = arguments[0];
      }
      const showResult = options.showResult !== false;
      const showSuccessMessage = options.showSuccessMessage !== false;
      const autoSubmitOnLeave = options.autoSubmitOnLeave === true;
      if (this.submittingAnswers) {
        return false;
      }
      this.submittingAnswers = true;
      const loadingInstance = this.$loading({
        text: autoSubmitOnLeave ? "正在自动交卷" : "正在提交"
      });
      const _this = this;
      const data = {
        userAnswerList: _this.questionAnswerList,
        ftId: _this.ftId
      };
      let res = null;
      try {
        res = await httpRequest("/app/formal-test/total", "put", data, {
          timeout: 30000,
          preserveErrorResponse: true,
          silentErrorMessage: true
        });
      } finally {
        loadingInstance.close();
      }
      this.submittingAnswers = false;

      if (res !== null && res !== undefined && res.code === 200) {
        this.clearTimer();
        if (showSuccessMessage) {
          this.$message.success("答卷已提交");
        }
        if (showResult) {
          this.showExamResult(_this, res.data);
        } else {
          this.isSubmitted = true;
        }
        return true;
      }

      if (autoSubmitOnLeave) {
        this.$message.error(
          "自动交卷失败，" +
            (res && res.message ? res.message : "请检查网络后重试")
        );
        return false;
      }

      // 出错的情况，弹窗重试
      this.$alert(
        "提交出错，" + (res && res.message ? res.message : "点击重试"),
        "提示",
        {
          confirmButtonText: "确定",
          showClose: false,
          callback: () => {
            _this.submitAnswers(options);
          }
        }
      );
      return false;
    },
    async loadQuestionList() {
      const routeFtId = this.getRouteFtId();
      // 根据传过来的参数来判断是何种形式，目前支持两种方式：做题&显示做题结果、直接显示某次考试的结果
      if (routeFtId) {
        // 显示单次考试结果页面
        const params = {
          ftId: routeFtId
        };
        const res = await httpRequest("/app/formal-test/info", "get", params);
        if (res !== null && res !== undefined && res.code === 200) {
          this.showExamResult(this, res.data);
          this.lastLoadedRouteKey = this.getCurrentRouteKey();
        }
        this.loadingQuestionList = false;
        return;
      }
      // 走正常的获取考试题目的界面
      const routeErId = this.getRouteErId();
      const res = await httpRequest(
        "/app/formal-test/questions",
        "get",
        routeErId ? { erId: routeErId } : null
      );
      if (res !== null && res !== undefined && res.code === 200) {
        if (
          res.data === null ||
          res.data === undefined ||
          res.data.length === 0 ||
          !(
            (res.data.examQuestionList !== null &&
              res.data.examQuestionList !== undefined &&
              res.data.examQuestionList.length !== 0) ||
            (res.data.examResult !== null && res.data.examResult !== undefined)
          )
        ) {
          this.loadingQuestionList = false;
          this.$message.error("数据异常，请重新进入考试");
          return;
        }
        if (res.data.examResult !== null && res.data.examResult !== undefined) {
          // 如果是考试完成的情况，则直接显示考试结果
          this.showExamResult(this, res.data.examResult);
          this.loadingQuestionList = false;
          return;
        }

        this.isSubmitted = false;
        this.questionList = res.data.examQuestionList;
        this.majorName = res.data.majorName;
        this.timerDuration = res.data.formalTestDuration;
        this.examTotalDuration = res.data.formalTestDuration;
        this.ftId = res.data.ftId;

        // 初始化用户答案列表参数questionAnswerList，与问题个数相同，每一个都设置格式为：{"peqid"："123"，"answer":"A,B"}
        this.questionAnswerList = new Array(this.questionList.length);
        this.optionSelectList = new Array(this.questionList.length);
        for (
          let qalIdx = 0;
          qalIdx < this.questionAnswerList.length;
          qalIdx++
        ) {
          this.questionAnswerList[qalIdx] = {
            ftqId: this.questionList[qalIdx].ftqId,
            answer: "",
            eqId: this.questionList[qalIdx].eqId
          }; // 初始化为未作答状态
          const options = this.questionList[qalIdx].optionList;
          let optionObj = {}; // {A:true, B:false}
          options.forEach(option => {
            Vue.set(optionObj, option.sort, false); // 每道题的每个选项的选中状态都先设置为false
          });
          Vue.set(this.optionSelectList, qalIdx, optionObj);
        }

        this.renderQuestion();
        // 开启定时器
        this.clearTimer();
        const _this = this;
        _this.timerStr =
          (_this.timerDuration / 60 < 10
            ? "0" + parseInt(Math.max(0, parseInt(_this.timerDuration / 60)))
            : parseInt(Math.max(0, parseInt(_this.timerDuration) / 60))) +
          ":" +
          (_this.timerDuration % 60 < 10
            ? "0" + parseInt(_this.timerDuration % 60)
            : parseInt(_this.timerDuration % 60));
        this.timer = setInterval(function() {
          _this.timerDuration--;
          _this.timerStr =
            (_this.timerDuration / 60 < 10
              ? "0" + parseInt(Math.max(0, parseInt(_this.timerDuration / 60)))
              : parseInt(Math.max(0, parseInt(_this.timerDuration) / 60))) +
            ":" +
            (_this.timerDuration % 60 < 10
              ? "0" + parseInt(_this.timerDuration % 60)
              : parseInt(_this.timerDuration % 60));
          if (_this.timerDuration <= 0) {
            // 提交问卷
            _this.clearTimer();
            // 弹窗提醒
            _this.$alert("倒计时结束，自动交卷", "提示", {
              confirmButtonText: "确定",
              showClose: false,
              callback: () => {
                // 提交问卷
                _this.submitAnswers();
              }
            });
          }
        }, 1000);
        this.lastLoadedRouteKey = this.getCurrentRouteKey();
        this.loadingQuestionList = false;
      } else {
        this.loadingQuestionList = false;
      }
    },
    // 跳到指定问题
    jump2Question(index) {
      this.currentQuestionIdx = index;
      this.renderQuestion();
    },
    showFile(file) {
      this.paperFile = file;
      this.paperName = file.name;
    },
    delFile() {
      if (this.uploadingPaper) {
        return;
      }
      this.paperName = "";
      this.paperFile = null;
    },
    async uploadFile(params) {
      if (this.paperFile === null) {
        this.$message.error("请先选择文件，再上传");
        return;
      }
      if (this.uploadingPaper) {
        return;
      }
      this.uploadingPaper = true;
      const formData = new FormData();
      formData.append(params.filename, params.file);

      let res = await httpRequest(params.action, "post", formData);
      if (res !== null && res !== undefined && res.code === 200) {
        // 拿到文件url
        const data = {
          paperUrl: res.data[0],
          paperName: this.paperName,
          ftId: this.examResult.ftId
        };
        res = await httpRequest("/app/exam/apply/upload-paper", "put", data);
        if (res !== null && res !== undefined && res.code === 200) {
          this.$message.success("上传成功，等待审核");
          this.paperAuthStatus = res.data.paperAuthStatus;
          this.paperName = res.data.fileName;
          this.examResult.paperAuthStatus = res.data.paperAuthStatus;
          this.examResult.fileName = res.data.fileName;
        }
      }
      this.$nextTick(() => {
        this.uploadingPaper = false;
      });
    },
    handlePaperUploadError() {
      // this.$message.error("上传失败，请重试");
    },
    // 重新考试
    re_exam() {
      if (
        this.examResult.leftTimes !== null &&
        this.examResult.leftTimes !== undefined &&
        this.examResult.leftTimes !== 0
      ) {
        this.$confirm("您还剩一次考试机会，请谨慎考虑", "提示", {
          confirmButtonText: "我想好了",
          cancelButtonText: "我再想想",
          type: "warning"
        })
          .then(() => {
            // 重新请求问题
            this.loadQuestionList();
          })
          .catch(() => {});
      } else {
        this.$alert("考试已结束", "提示", {
          type: "warning"
        });
      }
    }
  }
};
